import { ongletsMock } from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [ongletsMock];

export const laPoseMock: SlugPage = {
  ...pageBase({
    title: 'La Pose',
    type: 'la-pose',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
